import React from 'react';
export const GuaranteeSection = () => {
  return <section className="bg-familia-bg py-10 md:py-16 px-4 md:px-6" data-id="element-92" data-mp="1i59cuazedlrf">
      <div className="max-w-3xl mx-auto w-[92%] md:w-full" data-id="element-93" data-mp="4w1gmts656jd">
        <div className="bg-familia-card border-2 border-familia-gold p-8 md:p-16 rounded-[2rem] md:rounded-[2.5rem] text-center relative overflow-hidden" data-id="element-94" data-mp="9umi0wj5pw9e">
          <div className="text-5xl md:text-7xl mb-6 md:mb-10" data-id="element-95" data-mp="eur02qzpqz1q">🛡️</div>
          <h2 className="text-[22px] sm:text-2xl md:text-4xl font-display font-bold mb-6 md:mb-8 uppercase tracking-wider" data-id="element-96" data-mp="jrhfrd7lvsmm">
            Try Vitality 360™ at Home With Confidence
          </h2>

          <div className="text-familia-gray text-[15px] md:text-xl leading-relaxed mb-6 md:mb-10 max-w-xl mx-auto" data-id="element-97" data-mp="skkox9b7xjbg">
            <p data-id="element-98" data-mp="xim8rwggxmnz">
              Download the materials, explore the activities and see how the
              system fits into your family's routine. If it isn't right for you,
              simply follow the 60-day guarantee policy shown on this page. We
              want you to feel confident about your decision.
            </p>
          </div>

          <div className="inline-block bg-familia-green text-familia-bg font-bold px-5 md:px-6 py-2 rounded-full text-xs md:text-sm" data-id="element-99" data-mp="20su2uzi08hpf">
            60-Day Money-Back Guarantee
          </div>
        </div>
      </div>
    </section>;
};